/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersdescription1Inputs */

const en_membersdescription1 = /** @type {(inputs: Membersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For clubs, student societies and teams. Your events stay visible to everyone. For each event you choose whether everyone sees it or only your members.`)
};

const de_membersdescription1 = /** @type {(inputs: Membersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Vereine, Studentenverbindungen und Teams. Deine Events bleiben für alle sichtbar. Bei jedem Event wählst du, ob es alle sehen oder nur deine Mitglieder.`)
};

/**
* | output |
* | --- |
* | "For clubs, student societies and teams. Your events stay visible to everyone. For each event you choose whether everyone sees it or only your members." |
*
* @param {Membersdescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersdescription1 = /** @type {((inputs?: Membersdescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersdescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersdescription1(inputs)
	return de_membersdescription1(inputs)
});
export { membersdescription1 as "membersDescription" }